module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTMyMCA2NzJhMzIgMzIgMCAwIDAgMCA2NGg0ODBhMzIgMzIgMCAwIDAgMC02NEgzMjB6IG0tMTkyIDB2NjRoNjR2LTY0SDEyOHogbTE5Mi0xOTJhMzIgMzIgMCAwIDAgMCA2NGg0ODBhMzIgMzIgMCAwIDAgMC02NEgzMjB6IG0tMTkyIDB2NjRoNjR2LTY0SDEyOHogbTE5Mi0xOTJhMzIgMzIgMCAwIDAgMCA2NGg0ODBhMzIgMzIgMCAwIDAgMC02NEgzMjB6TTEyOCAyODh2NjRoNjRWMjg4SDEyOHoiIGZpbGw9IiMwIiBwLWlkPSI1MjYyIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Menu-outlined.svg
// module id = bjA6
// module chunks = 75